import { z } from 'zod';
import { TipTapContentSchema } from '../tiptap-content.schema';

export const BaseTeacherPinSettingsSchema = z.object({
  notes: TipTapContentSchema,
});
